let SQLite = null
try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { Platform } = require('react-native')
    if (Platform?.OS !== 'web') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        SQLite = require('expo-sqlite')
    }
} catch {}
import { isWeb, getPlatform } from '../src/utils/platformUtils'
let __dbModule = null
const buildLocalWrappedDb = () => {
    if (globalThis.__DOTS_SQLITE_WRAPPED_DB) {
        return globalThis.__DOTS_SQLITE_WRAPPED_DB
    }
    try {
    if (!SQLite) throw new Error('SQLite not available (web stub)')
    const localDb = SQLite.openDatabaseSync('myDB')
        if (getPlatform().OS === 'android') {
            try { localDb.execSync('PRAGMA journal_mode = WAL;') } catch {}
        }
        const wrapStatement = (stmt) => ({
            executeSync: (params = []) => {
                const res = stmt.executeSync(params)
                const rowsArray = Array.isArray(res?.rows) ? res.rows : Array.isArray(res?.rows?._array) ? res.rows._array : []
                return {
                    ...res,
                    getAllSync: () => rowsArray,
                    getFirstSync: () => (rowsArray && rowsArray.length ? rowsArray[0] : null),
                }
            },
            finalizeSync: () => stmt.finalizeSync(),
        })
        const wrapped = {
            execSync: (sql) => localDb.execSync(sql),
            prepareSync: (sql) => {
                const stmt = localDb.prepareSync(sql)
                const wrapped = wrapStatement(stmt)
                return {
                    executeSync: wrapped.executeSync,
                    finalizeSync: wrapped.finalizeSync,
                    getAllSync: (params = []) => wrapped.executeSync(params).getAllSync(),
                    getFirstSync: (params = []) => wrapped.executeSync(params).getFirstSync(),
                }
            },
        }
        globalThis.__DOTS_SQLITE_WRAPPED_DB = wrapped
        return wrapped
    } catch (e) {
        console.error('Fallback SQLite wrapper (tracking) failed:', e)
        return null
    }
}
const getWrappedDB = () => {
    if (!__dbModule) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        __dbModule = require('../src/db/indexDB')
    }
    const fromIndex = __dbModule?.getNativeDB ? __dbModule.getNativeDB() : null
    return fromIndex || buildLocalWrappedDb()
}
import { PORTFOLIO_STORE_NAMES } from '../src/db/constants'
export const TRACKINGS = {
    TRACKINGS: 'trackings',
}

const database = 'myDB'

const openDatabase = () => {
    if (isWeb()) {
        // Web usa IndexedDB directamente en los métodos; devolvemos stub seguro
        return { transaction: () => ({ executeSql: () => {} }) }
    }

    const dbSync = getWrappedDB()
    const facade = {
        execSync: (sql) => dbSync.execSync(sql),
        prepareSync: (sql) => dbSync.prepareSync(sql),
        transaction: (callback, errorCallback, successCallback) => {
            try {
                const tx = {
                    executeSql: (sql, params = [], success, error) => {
                        try {
                            const isSelect = /^\s*SELECT/i.test(sql)
                            if (isSelect) {
                                const stmt = dbSync.prepareSync(sql)
                                const rowsArray = stmt.getAllSync(params)
                                stmt.finalizeSync()
                                const rows = {
                                    length: rowsArray.length,
                                    item: (i) => rowsArray[i],
                                    _array: rowsArray,
                                }
                                const result = { rows, rowsAffected: 0, insertId: undefined }
                                success && success(tx, result)
                            } else {
                                const stmt = dbSync.prepareSync(sql)
                                stmt.executeSync(params)
                                stmt.finalizeSync()
                                const changes = dbSync.prepareSync('SELECT changes() as rowsAffected').getFirstSync()
                                const lastId = /\bINSERT\b/i.test(sql)
                                    ? dbSync.prepareSync('SELECT last_insert_rowid() as insertId').getFirstSync()
                                    : { insertId: undefined }
                                const result = {
                                    rows: { length: 0, item: () => undefined, _array: [] },
                                    rowsAffected: changes?.rowsAffected ?? 0,
                                    insertId: lastId?.insertId,
                                }
                                success && success(tx, result)
                            }
                        } catch (e) {
                            if (error) return error(tx, e)
                            throw e
                        }
                    },
                }
                callback && callback(tx)
                successCallback && successCallback()
            } catch (e) {
                errorCallback && errorCallback(e)
            }
        },
    }

    return facade
}

export const db = openDatabase()

class trackingServices {
    constructor() {
        this.db = db
    }

    addTracking = async (interaction_id, type_interaction, table) => {
        console.log('🚀 addTracking (wrapper)')
        
        // ✅ Usar la nueva implementación
        const trackingRepository = await import('../db-sqlite/repositories/tracking.repository')
        return await trackingRepository.addTracking(interaction_id, type_interaction, table)
    }

    getTrackings = async () => {
        console.log('📊 getTrackings (wrapper)')
        
        // ✅ Usar la nueva implementación
        const trackingRepository = await import('../db-sqlite/repositories/tracking.repository')
        return await trackingRepository.getTrackings()
    }

    deleteTrackingsFromLocal = async () => {
        console.log('🗑️ deleteTrackingsFromLocal (wrapper)')
        
        // ✅ Usar la nueva implementación
        const trackingRepository = await import('../db-sqlite/repositories/tracking.repository')
        return await trackingRepository.deleteAllTrackings()
    }

    deleteTrackingByIdFromLocal = async (trackingId) => {
        console.log('🗑️ deleteTrackingByIdFromLocal (wrapper) =>', trackingId)
        
        // ✅ Usar la nueva implementación
        const trackingRepository = await import('../db-sqlite/repositories/tracking.repository')
        return await trackingRepository.deleteTrackingById(trackingId)
    }
}

export const TrackingServices = new trackingServices(db)
